"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/Users/robertvunabandi/Desktop/Projects/aidos-server-python/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var _slicedToArray2 = _interopRequireDefault(require("/Users/robertvunabandi/Desktop/Projects/aidos-server-python/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _ImageCandidateActions = _interopRequireDefault(require("web/shared/imageCandidates/ImageCandidateActions"));
var _ImageCandidateStrip = require("web/shared/imageCandidates/ImageCandidateStrip.styles");
var _imageCandidateWording = require("web/shared/imageCandidates/imageCandidateWording");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
* One candidate in the strip: the picture at the strip's height, in a
* border that says whether it is the one shown — the accent for the chosen
* one, gray for the rest — and, while pointing at it, the candidate's
* actions rising onto its foot, with the view action opening it full
* screen.
*
* A candidate just chosen gets the accent on the spot, with a ring that
* swells out from its border as the card gives one small pulse.
*/ // Where a picture is in the window, for the full-screen view to grow out
// of; null when it is not laid out.
function boxOf(picture) {
  if (picture == null) {
    return null;
  }
  const rect = picture.getBoundingClientRect();
  return {
    top: rect.top,
    left: rect.left,
    width: rect.width,
    height: rect.height
  };
}
function ImageCandidateCard(props) {
  var _candidate$objectKey$;
  const candidate = props.candidate,
    choosing = props.choosing;
  const wording = (0, _imageCandidateWording.useImageCandidateWording)();
  const chosen = candidate.selection === "CHOSEN" || choosing;
  const name = (_candidate$objectKey$ = candidate.objectKey.split("/").pop()) !== null && _candidate$objectKey$ !== void 0 ? _candidate$objectKey$ : candidate.objectKey;
  const picture = (0, _react.useRef)(null); // Whether the pointer is over the card or the keyboard is inside it,
  // which is when its actions show.
  const _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    pointed = _useState2[0],
    setPointed = _useState2[1];
  const _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    focused = _useState4[0],
    setFocused = _useState4[1];
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("li", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_ImageCandidateStrip.styles.candidate, chosen && _ImageCandidateStrip.styles.candidateChosen, choosing && _ImageCandidateStrip.styles.candidateChoosing)), {}, {
    "aria-current": chosen ? "true" : undefined,
    onMouseEnter: () => setPointed(true),
    onMouseLeave: () => setPointed(false),
    onFocus: () => setFocused(true),
    onBlur: event => {
      // Only a blur that leaves the card hides the actions; moving
      // between its buttons keeps them.
      const next = event.relatedTarget;
      if (!(next instanceof Node) || !event.currentTarget.contains(next)) {
        setFocused(false);
      }
    },
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", (0, _objectSpread2.default)({
      ref: picture,
      src: candidate.url,
      width: candidate.width,
      height: candidate.height,
      alt: "".concat(chosen ? wording.chosenName : wording.candidateName, " ").concat(name)
    }, stylex.props(_ImageCandidateStrip.styles.picture))), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_ImageCandidateStrip.styles.candidateActions, (pointed || focused || choosing) && _ImageCandidateStrip.styles.candidateActionsShown)), {}, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ImageCandidateActions.default, {
        candidate: candidate,
        only: props.only,
        choosing: choosing,
        busy: props.busy,
        view: {
          name: "expand",
          label: "View ".concat(name, " full screen"),
          title: "Full screen",
          onPress: () => props.onView(boxOf(picture.current))
        },
        onChoose: props.onChoose,
        onDelete: props.onDelete
      })
    }))]
  }));
}
var _default = exports.default = ImageCandidateCard;